import React from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react'

import {AlertTypes} from '../../common/enums/index'

const ModalAlert = ({show=false,type,title,alertMsg, onConfirm, onCloseModal}) => {

    return (
            <CModal 
                show={show} 
                onClose={onCloseModal}
                color={
                    type===AlertTypes.Alert_Danger? "danger":
                    type===AlertTypes.Alert_Warning? "warning":
                    type===AlertTypes.Alert_Success? "success":
                    "info"
                }
            >
                <CModalHeader closeButton>
                    <CModalTitle>{title}</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    {alertMsg}
                </CModalBody>
                <CModalFooter>
                    {
                        type===AlertTypes.Alert_Info? null:
                        (<>
                            <CButton color={type===AlertTypes.Alert_Danger? "danger":"warning"} onClick={onConfirm}>Proceed</CButton>
                            {' '}
                        </>)
                    }
                    <CButton color="secondary" onClick={onCloseModal}>Close</CButton>
                </CModalFooter>
            </CModal>
        )
}

export default ModalAlert
